import { FAIcon } from "../../../core/components/faIcon.js";
import { Button } from "../../../core/components/button.js";
import { Helper } from "../../../core/util/helper.js";
import { HTTPService } from "../../../core/util/httpManager.js";
import { NotificationHelper } from "../../../core/util/notificationHelper.js";
import { Commands } from "../../../core/util/commandManager.js";
import { CommandManagerAPI, StringKeyDictionary } from "../../../commonInterfaces.js";
import {OpenAddressCoordinatesEmbedded} from "../../../core/components/gmEmbedApi.js";
import React from "react";
export class GeocodeStatus extends React.Component<GeocodeStatusProps, any> {
    translations: StringKeyDictionary<string>;

    constructor(props) {
        super(props);

        this.state = {
            Laengegrad: 0,
            Breitegrad: 0
        };
    }

    componentDidMount() {
        Helper.getTranslations(["WebSMS.Geodata.AdressFound", "WebSMS.Geodata.NoCoorinates", "WebSMS.Geodata.ShowOnMap"]).then(result => {
            this.translations = result.Data;
            this.setState({});
        });
    }

    updateGeodataLongLat = (long: number, lat: number) => {
        var props = {
            Laengegrad: long,
            Breitegrad: lat
        }
        if (this.props.onGeocodeDataChange != null)
            this.props.onGeocodeDataChange(long, lat);
        this.setState(props);
    }

    handleDeleteClick = () => {
        this.updateGeodataLongLat(0, 0)
    }

    elementReady = (selector) => {
        return new Promise((resolve, _) => {
            const el = document.querySelector(selector);
            if (el) {
                resolve(el);
            }
            new MutationObserver((mutationRecords, observer) => {
                // Query for elements matching the specified selector
                Array.from(document.querySelectorAll(selector)).forEach((element) => {
                    resolve(element);
                    //Once we have resolved we don't need the observer anymore.
                    observer.disconnect();
                });
            })
                .observe(document.documentElement,
                    {
                        childList: true,
                        subtree: true
                    });
        });
    }
    
    public static updateGecodeAddress = async (adrnr, strasse, plz, ort, land, currLat, currLong, force = true): Promise<GeodataUpdate> => {
        const res = {lat: 0, long: 0, changed: false} as GeodataUpdate;
        const gocode_res = await HTTPService.post("Geocode/GeocodeAddress",
            {
                adrNr: adrnr,
                strasse: strasse,
                plz: plz,
                ort: ort,
                land: land,
                forceRecalc: force || (currLat == 0 && currLong == 0)
            });
        if (gocode_res.Code === 0) {
            if (currLong == gocode_res.Data.Long &&
                currLat == gocode_res.Data.Lat)
                return res;
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.Geodata.AdressFound"));
            res.long = gocode_res.Data.Long;
            res.lat = gocode_res.Data.Lat;
            res.changed = true;
            return res;
        } else {
            if (!Helper.isNullOrEmpty(gocode_res.Message))
                NotificationHelper.showWarningMessage(gocode_res.Message);
            res.changed = true;
            return res;
        }
    }
    
    public static updateGecodeResource = async (ressnr, strasse, plz, ort, land, currLat, currLong, force = true): Promise<GeodataUpdate> => {
        const res = { lat: 0, long: 0, changed: false } as GeodataUpdate;
        const gocode_res = await HTTPService.post("Geocode/GeocodeRessource",
            {
                    ressNr: ressnr,
                    strasse: strasse,
                    plz: plz,
                    ort: ort,
                    land: land,
                    forceRecalc: force || (currLat == 0 && currLong == 0)});
            if (gocode_res.Code === 0) {
                if (currLat == gocode_res.Data.Lat &&
                    currLong == gocode_res.Data.Long)
                    return res;
                NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.Geodata.AdressFound"));
                res.long = gocode_res.Data.Long;
                res.lat = gocode_res.Data.Lat;
                res.changed = true;
                return res;
            } else {
                if (!Helper.isNullOrEmpty(gocode_res.Message))
                    NotificationHelper.showWarningMessage(gocode_res.Message);
                return res;
            }
    }
    
    public static updateTimeZone = async (lat: number, long: number) : Promise<string> => {
        if (!Helper.hasValue(lat) || !Helper.hasValue(long))
            return "";
        if (lat == 0 && long == 0)
            return "";
        const timezone_res = await HTTPService.post("Geocode/GetTimeZone", {lat: lat, long: long, forceRecalc: false});
        if (timezone_res.Code === 0) {
            return timezone_res.Data;
        } else
            return "";
    }

    render() {
        const canShowError = this.props.Laengegrad == null ||
            this.props.Breitegrad == null ||
            this.props.Laengegrad == 0 &&
            this.props.Breitegrad == 0;

        const nocoords = this.translations == null ? "" : this.translations["WebSMS.Geodata.NoCoorinates"];

        const text = canShowError && (this.props.GeocodeText == "" || this.props.GeocodeText == null)
            ? nocoords
            : this.props.GeocodeText;

        const iconName = canShowError ? "map-marker-alt-slash" : "map-marker-check";
        const icon =
            <span style={{ display: "inline-block", paddingRight: "10px", color: canShowError ? "red" : "#999" }
            }> <FAIcon name={iconName} /></span >;


        const errStyle: React.CSSProperties = {
            color: "red"
        };

        const normStyle: React.CSSProperties = {
            flex: 1
        };

        const showmap = this.translations == null ? "" : this.translations["WebSMS.Geodata.ShowOnMap"];

        const link = canShowError
            ? <span style={errStyle}>{text}</span>
            : <a style={normStyle} title={showmap} onClick={() => { OpenAddressCoordinatesEmbedded(this.props.commandManager) }}>{text}</a>;

        const btn = !canShowError && !this.props.manualLocation
            ? <Button buttonStyle={{ borderRadius: "var(--border-radius)", margin: "5px", height: "32px", width: "32px" }} handleClick={this.handleDeleteClick} iconName={"trash-alt"} readOnly={this.props.readOnly} />
            : null;

        const style: React.CSSProperties = {
            height: "fit-content",
            display: this.props.GeocodeEnabled ? "flex" : "none",
            alignItems: "center",
            paddingLeft: "14px",
            paddingRight: canShowError ? "14px" : "4px",
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "#999",
            borderRadius: "var(--border-radius)",
            minHeight: "38px"
        };

        let textEx = null;
        if (Helper.hasValue(this.props.GeocodeMatch) || Helper.hasValue(this.props.GeocodeDisplayName))
        {
            if (Helper.hasValue(this.props.GeocodeMatch) && Helper.hasValue(this.props.GeocodeDisplayName)) {
                textEx = this.props.GeocodeDisplayName + " - " + this.props.GeocodeMatch;
            } else
            {
                textEx =  Helper.hasValue(this.props.GeocodeMatch) ? this.props.GeocodeMatch : this.props.GeocodeDisplayName;
            }
        }

        let divMatch = null;
        if (Helper.hasValue(textEx)) {
            divMatch = (<div style={{
                marginTop: "5px",
                backgroundColor: "#fff19d",
                color: "#6a5b00",
                padding: "5px",
                border: "1px solid #fbc02d",
                borderRadius: "var(--border-radius)"

            }}>{textEx}</div>)
        }

        return (
            <>
                <div className="k-panelbar" style={style}>{icon}{link}{btn}</div>
                {divMatch}
            </>);
    }
}

interface GeodataUpdate {
    lat: number;
    long: number;
    changed: boolean;
}

interface GeocodeStatusProps {
    GeocodeEnabled: boolean;
    Laengegrad: number;
    Breitegrad: number;
    GeocodeText: string;
    GeocodeMatch: string;
    GeocodeDisplayName: string;
    onGeocodeDataChange?(long: number, lat: number): void;
    readOnly: boolean;
    manualLocation: boolean;
    Match?: string;
    commandManager: CommandManagerAPI;
}
